import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";
import { GoogleOAuthProvider } from "@react-oauth/google";

const container = document.getElementById("root");
const root = createRoot(container);


root.render(
    <GoogleOAuthProvider clientId="609859601794-r4eouiik3tvrpkt56rogq08r59mk34f7.apps.googleusercontent.com">
<App />
</GoogleOAuthProvider>
);
